// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"StickyShadow-primaryButton-3I7NdF","stickyShadow":"StickyShadow-stickyShadow-20O-X4","stickyShadowCover":"StickyShadow-stickyShadowCover-2GUQjF"};